import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10a30d5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-box" }
const _hoisted_2 = { class: "tree-box" }

import { ref, onMounted } from 'vue'
import CosFullLayout from '@/components/CosFullLayout/index.vue'
import Tree from './components/Tree.vue'
import MenuDetail from './components/MenuDetail.vue'
import { DcMessage } from '@dc-platform/dc-components'
import { useI18n } from 'vue-i18n'
import type { SystemSetting } from '@/types/systemSetting'
import { baseAll } from '@/api/systemSetting/index'
import { TreeDetail } from './hooks/enum'
import { usePermissionStore } from '@/stores/permission'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t } = useI18n()
const activeKey = ref<string>('cos_zbu_fbu')
const subdomain = ref<string>('')
const treeData = ref<SystemSetting.TreeData[]>([])
const treeDataPut = (data: SystemSetting.TreeData[]) => {
  data.forEach((item: SystemSetting.TreeData) => {
    // 在树结构最外层添加key值。为了expend可获取到对应值，实现展开背景色改色
    item.key = item.id
    if (item.children && item.children.length > 0) {
      treeDataPut(item.children)
    }
  })
}
const getBaseAll = async () => {
  try {
    let key: string = activeKey.value
    if (key.startsWith('cos_zbu_')) {
      if (key === 'cos_zbu_fbu') {
        subdomain.value = 'cos_fbu'
      } else if (key === 'cos_zbu_lbu') {
        subdomain.value = 'cos_lbu'
      }
      key = 'cos_zbu'
    } else {
      subdomain.value = ''
    }
    const res: any = await baseAll(
      {
        appId: key
      },
      {
        subdomain: subdomain.value
      }
    )
    treeData.value = res.data
    treeDataPut(treeData.value)
  } catch (error) {
    console.log('getBaseAll-error: ', error)
  }
}
const selectTreeDataId = ref<number>()
const selectTreeData = (node: number) => {
  selectTreeDataId.value = node
}
const emptyTreeData = () => {
  selectTreeDataId.value = TreeDetail.EMPTY
}
const handleChange = () => {
  getBaseAll()
}
const successRefresh = () => {
  getBaseAll()
}
const permissionStore = usePermissionStore()
const permissionBtn = ref()
permissionBtn.value = permissionStore.permission
const fromPermissionToResult = (value: string) => {
  const result = permissionBtn.value.includes(value)
  return result
}
const getData = () => {
  if (fromPermissionToResult('base_applyservice_zbu_fbu_btn')) {
    activeKey.value = 'cos_zbu_fbu'
  } else if (fromPermissionToResult('base_applyservice_zbu_lbu_btn')) {
    activeKey.value = 'cos_zbu_lbu'
  } else if (fromPermissionToResult('base_applyservice_fbu_btn')) {
    activeKey.value = 'cos_fbu'
  } else if (fromPermissionToResult('base_applyservice_ofbu_btn')) {
    activeKey.value = 'cos_ofbu'
  } else if (fromPermissionToResult('base_applyservice_lbu_btn')) {
    activeKey.value = 'cos_lbu'
  } else {
    activeKey.value = ''
    DcMessage.error('暂无权限！')
    return
  }
  getBaseAll()
}
const addData = ref()
const addNewService = (parentData: SystemSetting.AddDataType) => {
  selectTreeDataId.value = TreeDetail.ADDNEW
  addData.value = {
    ...parentData.data,
    appId: activeKey.value.startsWith('cos_zbu_') ? 'cos_zbu' : activeKey.value,
    subdomain: subdomain.value
  }
}
const showEdit = ref<any>(false)
const showEditEmit = (value: Boolean) => {
  showEdit.value = value
}
onMounted(() => {
  // getBaseAll()
  getData()
})

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createBlock(CosFullLayout, null, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_tabs, {
          activeKey: activeKey.value,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((activeKey).value = $event)),
          onChange: handleChange
        }, {
          default: _withCtx(() => [
            (fromPermissionToResult('base_applyservice_zbu_fbu_btn'))
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "cos_zbu_fbu",
                  tab: "谷仓市场营销"
                }))
              : _createCommentVNode("", true),
            (fromPermissionToResult('base_applyservice_zbu_lbu_btn'))
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "cos_zbu_lbu",
                  tab: "云途市场营销"
                }))
              : _createCommentVNode("", true),
            (fromPermissionToResult('base_applyservice_fbu_btn'))
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "cos_fbu",
                  tab: _unref(t)('system.jrmjeh'),
                  "force-render": ""
                }, null, 8, ["tab"]))
              : _createCommentVNode("", true),
            (fromPermissionToResult('base_applyservice_ofbu_btn'))
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "cos_ofbu",
                  tab: _unref(t)('system.enzdgq'),
                  "force-render": ""
                }, null, 8, ["tab"]))
              : _createCommentVNode("", true),
            (fromPermissionToResult('base_applyservice_lbu_btn'))
              ? (_openBlock(), _createBlock(_component_a_tab_pane, {
                  key: "cos_lbu",
                  tab: _unref(t)('system.j7x6fb')
                }, null, 8, ["tab"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["activeKey"])
      ])
    ]),
    aside: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Tree, {
          "tree-data": treeData.value,
          onSelectTreeData: selectTreeData,
          onEmptyTreeData: emptyTreeData,
          onAddNewService: addNewService,
          onSuccessRefresh: successRefresh,
          onShowEditEmit: showEditEmit
        }, null, 8, ["tree-data"])
      ])
    ]),
    main: _withCtx(() => [
      _createVNode(MenuDetail, {
        data: selectTreeDataId.value,
        addData: addData.value,
        showEdit: showEdit.value,
        onSuccessRefresh: successRefresh
      }, null, 8, ["data", "addData", "showEdit"])
    ]),
    _: 1
  }))
}
}

})